// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"360":"592182c1","707":"925c763b"}[chunkId] + ".chunk.js";
};